<template>
    <MainPage @clickBack="clickBack()" :showTopTitle="true">
        <div class="max-w-lg m-auto p-4" v-if="isInitial && isLoginAccount">
            <FormEditProfile ref="form-profile" :profile="profileModel"></FormEditProfile>
            <MarketingConsent ref="market-consent" :profile="profileModel"></MarketingConsent>
            <DeleteAccount></DeleteAccount>
            <div class="max-w-255px m-auto mt-8">
                <RedButton @click="clickSubmit()">
                    {{lbl.profile.update}}
                </RedButton>
            </div>
        </div>
    </MainPage>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue'
import FormEditProfile from '../component/FormEditProfile/FormEditProfile.vue';
import MarketingConsent from '../component/FormEditProfile/MarketingConsent.vue';
import DeleteAccount from '../component/FormEditProfile/DeleteAccount.vue';
import RedButton from '@/components/Button/RedButton.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import BzbsProfile from '@/core/Account/service/BzbsProfile';
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA';
import ChangePhoneApi from '../service/ChangePhoneApi.js';

export default {
    inject: ["AccountStore"],
    mixins: [AuthStatusMixin, ModalMixin, LocaleMixin],
    components: {
        MainPage,
        FormEditProfile,
        MarketingConsent,
        DeleteAccount,
        RedButton,
    },
    data: function () {
        return {
            profileModel: null,
            oldTel: null,
        };
    },
    created() {
    },
    methods: {
        //AuthStatusMixin
        onAccountInit: function () {
            this.profileModel = this.profile;
            this.oldTel = this.profile.contactNumber;

            Util.log('old tel', this.oldTel);
            // Util.log('profile', this.profile);
        },
        clickBack: function () {
            this.$router.back();
        },

        clickSubmit: function () {
            let rs = this.$refs['form-profile'].validateForm();
            // console.log('form error', rs);
            if (rs.rs === false) {
                this.modal.errorModal
                    .clearModal()
                    .setMsg(rs.error.msg)
                    .show();
                return;
            }

            this.saveProfile();
        },

        saveProfile: async function () {
            let profileModel = this.$refs['form-profile'].getFormValue();
            let params = profileModel.getParamsProfile();
            let marketConsent = this.$refs['market-consent'].getValue();

            console.log('update profile', params);
            console.log('market consent', marketConsent);

            let continueNextFlow = await this.flowUpdateContactNumber(profileModel.contactNumber);
            if (!continueNextFlow) {
                return;
            }

            this.modal.loadingModal.show();
            let profile = await this.apiUpdateProfile(params);
            if (profile == null) {
                this.modal.loadingModal.hide();
                return;
            }

            let consentRs = await this.apiUpdateConsent(marketConsent);
            await this.AccountStore.methods.checkSubscription();
            this.modal.loadingModal.hide();
            if (consentRs) {
                this.modal.successModal
                    .clearModal()
                    .setMsg('Update success')
                    .show();
                this.modal.successModal.onClose(() => {
                    this.$router.back();
                });
            }
        },

        apiUpdateProfile: function (params) {
            return new Promise((resolve) => {
                BzbsProfile.updateProfileBk(params).subscribe({
                    next: (profile) => {
                        resolve(profile);
                        this.setUpdateProfile(profile);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                    },
                });
            });
        },

        apiUpdateConsent: function (marketConsent) {
            return new Promise((resolve) => {
                BzbsPDPA.apiPostConsent(null, null, marketConsent).subscribe({
                    next: (data) => {
                        console.log('update consent', data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },

        flowUpdateContactNumber: function (newContactNumber) {
            return new Promise((resolve) => {
                if (newContactNumber == this.oldTel) {
                    // not change contact number
                    resolve(true);
                    return;
                }

                this.validateOtp(newContactNumber).then((rs) => {
                    resolve(rs);
                });
            });
        },

        validateOtp: function (newContactNumber) {
            return new Promise((resolve) => {
                this.modal.otpModal.clearModal()
                    .setTel(newContactNumber)
                    .setEnableRequestOtp()
                    .setOtpChanel('')
                    .startOtp()
                this.modal.otpModal.onSubmitOtp((otpModel) => {
                    ChangePhoneApi.apiChangeTelOtp(newContactNumber, otpModel.otp, otpModel.refcode).subscribe({
                        next: (res) => {
                            this.modal.otpModal.closeOtp();
                            console.log(res);
                            resolve(true);
                        },
                        error: (err) => {
                            // resolve(false);
                            console.log(err);
                            if (err.id == 2091) {
                                this.modal.otpModal.setErrorMsg('Invalid OTP, please try again.');
                                this.modal.otpModal.clearInputOtp();
                            } else {
                                this.errorApi(err);
                            }
                            // this.otpModal.setErrorMsg();
                        },
                    })
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
